import React, {FC, useState, useEffect} from "react"

import GenericModal from "@irati/ui/src/GenericModal"
import {Body, H2} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import teamsService from "@irati/identity/services/teams"
import {TeamAssignment} from "@irati/types"
import Badge from "@irati/ui/src/Badge"
import {useTheme} from "@irati/ui/src/global/useTheme"
import Button from "@irati/ui/src/Button"
import {Hr} from "@irati/ui/src/Layout"
import Loading from "@irati/ui/src/Loading"

import {Option} from "./index"

interface Props {
  showModal: boolean
  userTeams: Option[]
  userId?: string
  onHide: (updatedTeams: Option[]) => void
}
const EditManagersMoldal: FC<Props> = ({showModal, userTeams, userId, onHide}) => {
  const [teams, setTeams] = useState<Option[]>(userTeams)
  const [load, setLoad] = useState<Promise<any> | null>(null)
  const theme = useTheme()

  const handleRemoveManager = (team: Option) => {
    const loaded = teamsService.addUserToTeam(team.value, userId!, TeamAssignment.Basic).then(() => {
      const updatedTeams = teams.map((item) => ({
        value: item.value,
        label: item.value === team.value ? team.label.replace(`(${TeamAssignment.Manager})`, "") : item.label
      }))
      setTeams(updatedTeams)
    })
    setLoad(loaded)
  }

  const handleAssignManager = (team: Option) => {
    const loaded = teamsService.addUserToTeam(team.value, userId!, TeamAssignment.Manager).then(() => {
      const updatedTeams = teams.map((item) => ({
        value: item.value,
        label: item.value === team.value ? `${team.label}(${TeamAssignment.Manager})` : item.label
      }))
      setTeams(updatedTeams)
    })
    setLoad(loaded)
  }

  useEffect(() => {
    setTeams(userTeams)
  }, [userTeams])
  return (
    <GenericModal hideActions show={showModal} onHide={() => onHide(teams)}>
      <H2>
        <FormattedMessage id="account.editProfile.editManagers.title" />
      </H2>
      <Body marginTop={2}>
        <FormattedMessage id="account.editProfile.editManagers.subTitle" />
      </Body>
      <Loading load={load}>
        <Flex marginTop={5} direction="column" padding={[0, 2]}>
          {teams?.map((team) => (
            <>
              <Flex justifyContent="space-between" alignItems="center">
                <Flex alignItems="center">
                  <Body large>{team.label.replace(`(${TeamAssignment.Manager})`, "")}</Body>
                  {team.label.includes(TeamAssignment.Manager) && (
                    <Badge bgColor={theme.colors.primary2} color={theme.colors.greys.white} padding={[0, 1]} margin={[0, 1]}>
                      <FormattedMessage id="account.editProfile.editManagers.manager" />
                    </Badge>
                  )}
                </Flex>
                {team.label.includes(TeamAssignment.Manager) ? (
                  <Button tertiary onClick={() => handleRemoveManager(team)}>
                    <FormattedMessage id="account.editProfile.editManagers.removeManager" />
                  </Button>
                ) : (
                  <Button tertiary onClick={() => handleAssignManager(team)}>
                    <FormattedMessage id="account.editProfile.editManagers.assignAsManager" />
                  </Button>
                )}
              </Flex>
              <Hr margin={[2, 0]} />
            </>
          ))}
        </Flex>
      </Loading>
    </GenericModal>
  )
}

export default EditManagersMoldal
